module.exports = __webpack_public_path__ + "static/media/6_bill_worried.56cbbc10.svg";